/**
 * Typed API client (openapi-fetch over the Django Ninja OpenAPI document). Run `just gen-openapi`
 * to refresh `schema.d.ts`; until then the paths type falls back to a permissive shape.
 */
import createClient from "openapi-fetch";
import type { paths } from "./schema";

function csrfToken(): string | undefined {
  const m = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]+)/);
  return m?.[1];
}

export const api = createClient<paths>({ baseUrl: "/", credentials: "same-origin" });

api.use({
  onRequest({ request }) {
    if (!["GET", "HEAD", "OPTIONS"].includes(request.method)) {
      const t = csrfToken();
      if (t) request.headers.set("X-CSRFToken", t);
    }
    return request;
  },
});

export class ApiError extends Error {
  constructor(
    public status: number,
    public detail: string,
  ) {
    super(`${status}: ${detail}`);
  }
}

export function unwrap<T>(res: { data?: unknown; error?: unknown; response: Response }): T {
  if (res.error !== undefined || !res.response.ok) {
    const e = res.error as { detail?: string } | undefined;
    throw new ApiError(res.response.status, e?.detail ?? res.response.statusText);
  }
  return res.data as T;
}
